import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M17.4479012,0 L8.03358025,8.00968992 L0,22.1569767 L7.24345679,22.1569767 L17.4479012,0 Z M18.7002469,1.87403101 L14.6824691,12.9844961 L22.3861728,22.4806202 L7.44098765,25 L31.9348148,25 L18.7002469,1.87403101 Z" transform="translate(0 4)"/>
  </svg>
);
